import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BuilderGeneratedPageSectionI} from "../../../../../../../../builder-v2.interface";
import {FormControl} from "@angular/forms";

@Component({
    selector: 'db-section-fields',
    templateUrl: './section-fields.component.html',
    styleUrl: './section-fields.component.scss',
    standalone: false
})
export class SectionFieldsComponent {
  @Input() section: BuilderGeneratedPageSectionI;
  @Input() static: boolean;
  @Input('selected') set onSelected(selected: boolean) {
    this.selected = selected;
  }

  selected: boolean = false;
  @Input() titleForm: FormControl = new FormControl();
  @Input() descriptionForm: FormControl = new FormControl();
  @Output() isEdit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() valueChange: EventEmitter<{
    section_title: string;
    section_description: string;
  }> = new EventEmitter<{
    section_title: string;
    section_description: string;
  }>();
}
